/**
 * @generated SignedSource<<2e254a9c3e0c20564d5b9a63ed80e43a>>
 * @relayHash 2c5137c10743b2ac80ec13b0fa61aa4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39b843ae6ad7e8e9e1ebcb83439ed036191999d4eb4bd8d71f0415e7d80c9c5a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "39b843ae6ad7e8e9e1ebcb83439ed036191999d4eb4bd8d71f0415e7d80c9c5a",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
